import { useDocumentClassName } from "../../hooks/useDocumentClassName";

const Document = ({ className, children }) => {
  useDocumentClassName(className);

  return children;
};

export default Document;
